import React, {useEffect} from 'react';
import {Col, Row} from 'reactstrap';
import {connect} from "react-redux";

// components
import BenefitList from "./_list";
import BenefitForm from "./_form";
import {showToastCustom} from "../../../components/toast/customToast";
import {benefitService} from "../../../jwt/_services/promotions/benefitService";
import {showLoader} from "../../../components/loader/loader";
import {ButtonNew, ButtonSync} from "../../../components/buttons/buttonsActions";

// labels
import {error, success, updateMsg} from "../../../components/i18n/i18n";

// actions
import {
    clearState, setApp, setCategory,
    setLoading, setUdn, setViewMode
} from "../../../redux/actions/generalActions/mainActions";
import {setForm} from "../../../redux/actions/generalActions/formActions";
import {clearState as clearListState} from "../../../redux/actions/generalActions/listActions";

// service
import {langBenefitService} from "../../../jwt/_services/relations/langBenefitService";


const Benefit = (props) => {
    const { viewMode, loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);
    },[]);

    const syncFirebase = () => {
        props.setLoading(true);
        benefitService.syncFirebase()
            .then(_ => {
                props.setLoading(false);
            })
            .catch(errorMessage => {
                props.setLoading(false);
                showToastCustom(error, errorMessage);
            });

        langBenefitService.syncFirebase()
            .then(_ => {
                props.setLoading(false);
                showToastCustom(success, updateMsg);
            })
            .catch(errorMessage => {
                props.setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    const newItem = () => {
        props.setForm()
        props.setViewMode('FORM')
    }

    return (
        <div>
            {loading && showLoader()}
            {/*--------------------------------------------------------------------------------*/}
            {/* Header*/}
            {/*--------------------------------------------------------------------------------*/}

            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        {
                            viewMode === "LIST" ?
                                <div className="ml-auto paddingAdd">
                                    <ButtonSync onClick={syncFirebase}/>
                                    <ButtonNew onClick={newItem}/>
                                </div> : null
                        }
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    {(
                        function() {
                            switch (viewMode) {
                                case "LIST" :
                                    return <BenefitList />
                                case "FORM" :
                                    return <BenefitForm />
                                default:
                                    return null;
                            }
                        })()}
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setForm,
    setApp,
    setCategory,
    setViewMode,
    setLoading,
    clearListState
});

export default connect(mapStateToProps, mapActionsToProps)(Benefit)
